import React from 'react'

import RecommendArticlesOthers from '../aelComponent/RecommendArticlesOthers';
import RecommendArticlesWide from '../aelComponent/RecommendArticlesWide';
import './index.scss';

const RecommendArticles = props => {
    let {data} = props;
    return (
        <div className='recommendArticles'>
            <div className='recommendTitleBox'>
                <span className='spot'></span>
                <span className='spot'></span>
                <h2 className='recommendTitle'>相关文章</h2>
                <span className='spot spot3'></span>
                <span className='spot'></span>
            </div>
            {
                data && data.map((val, index) => {
                    return <div key={index}>
                        {
                            val.wideCover ? (
                                <RecommendArticlesWide index={index} data={val}/>
                            ) : (
                                <RecommendArticlesOthers index={index} haveLine={index !== data.length - 1} data={val}/>
                            )
                        }
                    </div>
                })
            }
        </div>
    )
}

export default RecommendArticles;